'use client'

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react'
import { LoggerUserContext } from './LoggerUserContext'

export function SessionProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextAuthSessionProvider>
      <LoggerUserContext />
      {children}
    </NextAuthSessionProvider>
  )
}
